import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { ActionContext } from '../layout/MainContainer';
import { getEndUserCompanyDetail } from '../../state/company/companySelector';
import ScrollTopButton from '../common/Scrollbar/ScrollTopButton';

import TranslateMessage from '../common/TranslateMessage/TranslateMessage';
import { APP_URL } from '../../configs/AppConfig';

const PublicFooter = props => {
  const {
    companyDetail,
    companyActions: { loadEndUserCompanyDetail }
  } = props;
  const location = useLocation();
  const isPreview = location.pathname.includes('preview');

  useEffect(() => {
    // Load company detail on page load
    loadEndUserCompanyDetail({ isPreview });
  }, []);

  useEffect(() => {
    // Set Favicon
    if (companyDetail && companyDetail.favicon) {
      const favicon = APP_URL.FAVICON_UPLOAD_PATH + '/' + companyDetail.favicon;
      const favElement = document.getElementById('favicon');
      favElement.href = favicon;
    }
  }, [companyDetail]);

  return (
    <footer className="footer mt-auto py-3 bg-secondary flex-shrink-0">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-6">
            <Link to={`${isPreview ? '/preview' : ''}/faq`} className="text-white">
              <TranslateMessage id="title.faqPage"/>
            </Link>
          </div>
          <div className="col-sm-12 col-md-6 text-right">
            <span className="text-white">{companyDetail.copyright}</span>
          </div>
        </div>
      </div>
      <ScrollTopButton/>
    </footer>
  );
};

PublicFooter.propTypes = {
  messageActions: PropTypes.object.isRequired,
  companyActions: PropTypes.object.isRequired,
  companyDetail: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    companyDetail: getEndUserCompanyDetail(state)
  };
};

export default connect(mapStateToProps)(
  props => (
    <ActionContext.Consumer>
      {({ messageActions, companyActions }) => (
        <PublicFooter
          {...props}
          messageActions={messageActions}
          companyActions={companyActions}
        />
      )}
    </ActionContext.Consumer>
  )
);
